import { Component, EventEmitter, Injectable, Input, OnInit, Output } from '@angular/core';
import { NgbCalendar, NgbCalendarIslamicUmalqura, NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

const WEEKDAYS_AR = ['إثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت', 'أحد'];
const WEEKDAYS_EN = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
const MONTHS_AR = ['محرم', 'صفر', 'ربيع الأول', 'ربيع الآخر', 'جمادى الأولى', 'جمادى الآخرة', 'رجب', 'شعبان', 'رمضان', 'شوال', 'ذو القعدة', 'ذو الحجة'];
const MONTHS_EN = ['Muharram', 'Safar', 'Rabi\'ul-Awwal', 'Rabi\'ul-Akhir', 'Jumadal-Ula', 'Jumadal-Akhir', 'Rajab', 'Sha\'ban', 'Ramadan', 'Syawwal', 'Dhul-Qa\'da', 'Dhul-Hijja'];
const language = localStorage.getItem('language') || 'en';
const MONTHS = language === 'en' ? MONTHS_EN : MONTHS_AR;
const WEEKDAYS = language === 'en' ? WEEKDAYS_EN : WEEKDAYS_AR;
@Injectable()
export class IslamicI18n extends NgbDatepickerI18n {
  getMonthShortName(month: number) {
    return MONTHS[month - 1];
  }

  getMonthFullName(month: number) {
    return MONTHS[month - 1];
  }

  getWeekdayLabel(weekday: number) {
    return WEEKDAYS[weekday - 1];
  }
  getWeekdayShortName(weekday: number) {
    return WEEKDAYS[weekday - 1];
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}

@Component({
  selector: 'app-islamic-picker',
  templateUrl: './islamic-picker.component.html',
  providers: [
    {provide: NgbCalendar, useClass: NgbCalendarIslamicUmalqura},
    {provide: NgbDatepickerI18n, useClass: IslamicI18n}
  ]
})

export class IslamicPickerComponent implements OnInit {
  selectedDate!: any;
  @Input() label!: string;
  @Input() disabled!: boolean;
  @Input() placement!: string;
  @Output() dateValueChange = new EventEmitter<any>();
  @Input() set dateValue(value: any) {
    this.selectedDate = value;
  }
  @Input() minDate!: NgbDateStruct;
  @Input() maxDate!: NgbDateStruct;

  today = this.calendar.getToday();

  constructor(
    private calendar: NgbCalendar
  ) { }

  ngOnInit(): void {
  }

  setDate(selected: any = null) {
    this.selectedDate = selected;
    this.dateValueChange.emit(this.selectedDate);
  }

}
